import { useParams } from 'react-router';
import { tryParseInternalId } from 'utils/internalId.validation';

/**
 * Use integer id from route path params
 */
export function useNumericIdRouteParam(key = 'resourceId'): number | undefined {
  const resourceId = useParams()[key];
  if (resourceId == null || resourceId === '') return undefined;

  return tryParseInternalId(resourceId);
}
